module.exports = __webpack_public_path__ + "static/media/Milovicka.8390ccc2.md";